import axios from 'axios';

import request from '../request';
import { SharedAPI } from './api-types';
import urls from './urls';
import { getMetadata, setMetadata } from './metadata';
import { Metadata } from './types';

export async function getFilePreSignedURL(
  payload: SharedAPI.GetFilePreSignedUrlRequest
): Promise<SharedAPI.GetFilePreSignedUrlResponse> {
  const { data } = await request.post<SharedAPI.GetFilePreSignedUrlResponse>(urls.getPreSignedURL, payload);
  return data;
}

export async function uploadFileToS3(
  payload: SharedAPI.UploadFileToS3Request
): Promise<SharedAPI.UploadFileToS3Response> {
  const { uploadUrl, file, contentType, signal } = payload;

  await axios.put(uploadUrl, file, {
    signal,
    headers: {
      'Content-Type': contentType,
    },
  });
}

export function setUrl(presentationId: string, slideId: string, url: Metadata['url']) {
  setMetadata(presentationId, slideId, { url });
}

export function getUrl(presentationId: string, slideId: string) {
  return getMetadata(presentationId, slideId, 'url');
}

export function setActivityType(
  presentationId: string,
  slideId: string,
  slideType: Metadata['slideType'],
  url: Metadata['url']
) {
  setMetadata(presentationId, slideId, { slideType, url });
}

export function getActivityType(presentationId: string, slideId: string) {
  return getMetadata(presentationId, slideId, 'slideType');
}
